<template>
    <el-drawer
        :title="isEdit ? '编辑知识点' : '添加知识点'"
        :visible.sync="drawer"
        :modal="true"
        :wrapperClosable="false"
        size="600px"
        @close="closeDrawer"
        :modal-append-to-body="false"
        :direction="direction">

        <!-- title -->
        <div class="drawer_form">
            
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
                
                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <el-form-item label="知识点编码" prop="code">
                            <el-input type="text" v-model="form.code" autocomplete="off" placeholder="请输入知识点编码"></el-input>
                        </el-form-item>
                        <el-form-item label="知识点名称" prop="name">
                            <el-input type="text" v-model="form.name" autocomplete="off" placeholder="请输入知识点名称"></el-input>
                        </el-form-item>
                        <el-form-item label="所属课程" prop="courseId">
                            <el-select v-model="form.courseId" class="w-full" placeholder="请选择课程" clearable>
                                <el-option
                                    v-for="item in courseList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属章节" prop="chapterId">
                            <el-select v-model="form.chapterId" class="w-full" placeholder="请选择章节" clearable>
                                <el-option
                                    v-for="item in chapterList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="描述" prop="description">
                            <el-input type="textarea" rows="4" v-model="form.description" autocomplete="off" placeholder="请输入描述"></el-input>
                        </el-form-item>
                        <el-form-item label="关联资源" prop="resourceId">
                            <el-select v-model="form.resourceId" class="w-full" placeholder="请选择关联资源" clearable filterable>
                                <el-option
                                    v-for="item in resourceList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="排序" prop="sort">
                            <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right"></el-input-number>
                        </el-form-item>
                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button @click="onSubmit" class="common-button">{{ isEdit ? '保存' : '添加' }}</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>
    
</template>

<script>
import { save, get } from '@/request/api/knowledge_graph.js'
import { lists as getResourceList } from '@/request/api/source.js'

export default {
    data() {
        return {
            drawer: true,
            direction: 'rtl',
            loading: false,
            isEdit: false,
            courseList: [], // TODO: 从课程接口加载
            chapterList: [], // TODO: 根据课程加载章节
            resourceList: [],
            form: {
                id: '',
                code: '',
                name: '',
                courseId: '',
                chapterId: '',
                description: '',
                resourceId: '',
                sort: 0
            },
            rules: {
                code: [
                    { required: true, message: '请输入知识点编码', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '请输入知识点名称', trigger: 'blur' },
                ]
            }
        }
    },
    created() {
        this.loadResourceList()
        
        // 判断是否为编辑模式
        if (this.$route.query.id) {
            this.isEdit = true
            this.loadData(this.$route.query.id)
        }
    },
    methods: {
        // 加载资源列表
        loadResourceList() {
            getResourceList({ page: 1, size: 1000 }).then(res => {
                this.resourceList = res.data.list || []
            })
        },
        // 加载知识点数据（编辑模式）
        loadData(id) {
            this.loading = true
            get(id).then(res => {
                if (res.code == 0 && res.data) {
                    this.form = {
                        id: res.data.id,
                        code: res.data.code || '',
                        name: res.data.name || '',
                        courseId: res.data.courseId || '',
                        chapterId: res.data.chapterId || '',
                        description: res.data.description || '',
                        resourceId: res.data.resourceId || '',
                        sort: res.data.sort || 0
                    }
                }
            }).finally(() => {
                this.loading = false
            })
        },
        onSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false
                }
            })
        },
        req() {
            save(this.form).then(res => {
                if (res.code != 0) return this.$notify({ title: '失败', message: res.msg, type: 'error' })
                this.$notify({ title: '成功', message: this.isEdit ? '更新成功' : '添加成功', type: 'success' })
                this.$router.go(-1)
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        closeDrawer() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="less" scoped>
.drawer_form {
    width: 96%;
    margin: auto;
    .drawer_form_title {
        color: #17233d;
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        line-height: 48px;
        margin-bottom: 20px;
    }

    .drawer_line {
        margin-bottom: 30px;
        .drawer_line_text {
            width: 120px;
            margin-right: 20px;
            text-align: right;
            color: #515a6e;
        }    
    }
}
.form-items {
    background-color: #f5f6fb;
    padding: 15px 10px;
    height: 500px;
}

/deep/ .form-items .el-form-item,
/deep/ .form-items .el-form-item .el-form-item__content {
    width: 100%;
}

.w-full {
    width: 100%;
}
</style>
